import { setThemePref, useThemePref, type ThemePref } from "../theme";
import { SegInd } from "./Kit";
import { ShellIcon, type ShellIconName } from "./ShellIcons";

const OPTIONS: Array<[ThemePref, string, ShellIconName]> = [
  ["system", "系统", "monitor"],
  ["light", "浅色", "sun"],
  ["dark", "深色", "moon"],
];

/**
 * How the console looks: 系统 / 浅色 / 深色, in the account menu and in the
 * phone's 更多 (prototype v2.15: only there, never twice in the sidebar). Both
 * draw the one choice the page holds (theme.ts useThemePref).
 */
export default function ThemeSwitch() {
  const pref = useThemePref();
  return (
    <div className="lz-seg" role="radiogroup" aria-label="外观">
      <SegInd />
      {OPTIONS.map(([k, label, icon]) => (
        <button key={k} type="button" role="radio" aria-checked={pref === k} className={pref === k ? "on" : ""} onClick={() => setThemePref(k)}>
          <ShellIcon name={icon} size={14} />
          {label}
        </button>
      ))}
    </div>
  );
}
